import { render, staticRenderFns } from "./sectionChild.vue?vue&type=template&id=597ad084"
import script from "./sectionChild.vue?vue&type=script&lang=js"
export * from "./sectionChild.vue?vue&type=script&lang=js"
import style0 from "./sectionChild.vue?vue&type=style&index=0&id=597ad084&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports